export default __webpack_public_path__ + "static/media/temperature.98110415.svg";